import React from 'react';

const RefreshButton = props => {
  return (
    <button
      type="button"
      className={`${props.className} btn btn-secondary btn-icon`}
      onClick={props.onClick}
    >
      <span className="btn-inner--icon">
          <i className="fas fa-redo"></i>
      </span>
      <span className="btn-inner--text">Refresh</span>
    </button>
  )
}

export default RefreshButton;
